import { defineComponent as _defineComponent } from 'vue'
import { ExternalCompany, OutsetStrikeNumberReport } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { startCase, sumBy } from "lodash";
import { customMoment } from "@/main";
import { queries } from "@/apollo";
import { formatCount } from "@/helpers/formatCount";
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'OutsetStrikeStatementsModal',
  props: {
    value: { type: Boolean },
    startReleaseDate: null,
    endReleaseDate: null,
    userId: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  startReleaseDate?: string;
  endReleaseDate?: string;
  userId: ExternalCompany["userId"];
};





const { $t } = useTranslation();

const { result: strikeNumberOutsetReportsResult, loading } = useQuery<{
  strikeNumberOutsetReports: OutsetStrikeNumberReport[];
}>(queries.strikeNumberOutsetReports, {
  releaseDateStart: props.startReleaseDate,
  releaseDateEnd: props.endReleaseDate,
  userId: computed(() => props.userId),
});

const strikeNumberOutsetReports = computed(() => {
  return strikeNumberOutsetReportsResult.value?.strikeNumberOutsetReports;
});

const processedStrikeNumberReports = computed(() => {
  return strikeNumberOutsetReports.value
    ?.map((report) => {
      return {
        ...report,
        summary: {
          big: sumBy(report.rows, (row) => row.big),
          small: sumBy(report.rows, (row) => row.small),
          strikeAmount: sumBy(report.rows, (row) => row.strikeAmount),
        },
      };
    })
    .sort((a, b) => {
      return customMoment(a.releaseDate).isAfter(customMoment(b.releaseDate))
        ? -1
        : 1;
    });
});

function formatDate(date: string) {
  return customMoment(date).format("DD MMM YYYY");
}
function formatDatetime(date: string) {
  return customMoment(date).format("DD/MMM HH:mm:ss");
}

function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, emit, $t, strikeNumberOutsetReportsResult, loading, strikeNumberOutsetReports, processedStrikeNumberReports, formatDate, formatDatetime, toggleModal, formatDollar, startCase, formatCount }
}

})